/**
 * Clickable address — opens Google Maps directions in a new tab.
 * Falls back to plain text if no address is provided.
 */
import React from 'react';
import { MapPin } from 'lucide-react';

export function mapsUrl(address) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

export default function ClickableAddress({ address, className = '', iconSize = 14, testId, lines = false }) {
  if (!address) return null;
  return (
    <a
      href={mapsUrl(address)}
      target="_blank"
      rel="noreferrer"
      data-testid={testId || 'clickable-address'}
      className={`inline-flex items-start gap-1.5 hover:text-heritage underline-offset-2 hover:underline transition-colors ${className}`}
      onClick={(e) => e.stopPropagation()}
      title="Open in Google Maps"
    >
      <MapPin size={iconSize} className="mt-0.5 shrink-0" />
      <span className={lines ? 'whitespace-pre-line' : ''}>{address}</span>
    </a>
  );
}
